import {
  alpha,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  Tabs,
  Tab,
  TabPanel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { visuallyHidden } from '@mui/utils';
import ApiService from '../../services/ApiService';
import ButtonUser from '../../pages/IncidentManagement/Component/ButtonUser';
import { DropdownActionLkp } from '../Button/DropdownActionLkp';
import DialogIncidentAlert from '../Dashboard/DialogIncidentAlert';
import DialogCustom from '../DialogCustom';
import DialogAssignPic from '../Dashboard/DialogAssignPic';
import { useNavigate } from 'react-router';
import Badge from '@mui/material/Badge';
import DialogDeleteConfirmation from '../Dashboard/DialogDeleteConfirmation';
import ExcelIcon from '../Icon/ExcelIcon';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import WarningAmberIcon from "@mui/icons-material/WarningAmber";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, numSelected, rowCount, onRequestSort, columns } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead sx={{ width: '100%' }}>
      <TableRow>
        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          LKP List
        </Typography>
      )}

      {/* <Tooltip title="Delete">
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          onClick={() => alert("Delete Selected")}
          disabled={numSelected <= 0}
        >
          Delete
        </Button>
      </Tooltip> */}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const TableBawah = ({ columns, EditData, DeleteData, CreateData }) => {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [pageTaskLkp, setPageTaskLkkp] = useState(0);
  const [pageLapInvest, setPageLapInvest] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageTaskLkp, setRowsPerPageTaskLkp] = useState(5);
  const [rowsPerPageLapInvest, setRowsPerPageLapInvest] = useState(5);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState([]);
  const [rowsTaskLkp, setRowsTaskLkp] = useState([]);
  const [rowsLapInvest, setRowsLapInvest] = useState([]);
  const [authorizeAction, setAuthorizeAction] = useState(null);

  const [totalRow, setTotalRow] = useState(null);
  const [totalRowTaskLkp, setTotalRowTaskLkp] = useState(null);
  const [totalRowLapInvest, setTotalRowLapInvest] = useState(null);

  const [dataRegion, setDataRegion] = useState([]);
  const [hipo, setHipo] = useState(null);
  const [dataLokasi, setDataLokasi] = useState([]);
  const [dataTahun, setDataTahun] = useState([]);
  const [dataInsiden, setDataInsiden] = useState([]);
  const [dataSearch, setDataSearch] = useState('');

  const [regionId, setRegionId] = useState(0);
  const [locationId, setLocationId] = useState(0);
  const [year, setYear] = useState(0);
  const [tipeKejadianId, setTipeKejadianId] = useState(0);
  const [filterSearch, setFilterSearch] = useState('');
  const [filterNoInvestigasi, setFilterNoInvestigasi] = useState('');
  const navigate = useNavigate();
  // const [newColumns, setNewColumns] = useState(columns);
  const [newColumnsTaskLkp, setNewColumnsTaskLkp] = useState([]);
  const [newColumnsLapInvest, setNewColumnsLapInvest] = useState([]);
  const [value, setValue] = React.useState(0);
  const [isBadgeTaskLKP, setIsBadgeTaskLKP] = useState(false);
  const [isBadgeLapInvest, setIsBadgeLapInvest] = useState(false);
  // Fetch Data
  useEffect(() => {
    // if (value == 0) {
    getPostTaskListSummaryVerifikator();
    // } else if (value == 1) {
    getPostMyLkpTaskListSummaryVerifikator();
    // } else {
    getPostMyLapInvestTaskListSummaryVerifikator();
    // }
  }, [
    page,
    pageTaskLkp,
    pageLapInvest,
    rowsPerPage,
    rowsPerPageTaskLkp,
    rowsPerPageLapInvest,
    regionId,
    locationId,
    year,
    tipeKejadianId,
    filterSearch,
    hipo,
    filterNoInvestigasi,
  ]);

  const getPostTaskListSummaryVerifikator = async () => {
    await setRows([]);
    setLoading(true);

    // setNewColumns([
    //   {
    //     id: "nomorLaporan",
    //     label: "No LKP",
    //   },
    //   {
    //     id: "judulLaporan",
    //     label: "Judul",
    //   },
    //   {
    //     id: "tanggalLaporan",
    //     label: "Date Reported",
    //   },
    //   {
    //     id: "tipeIncident",
    //     label: "Tipe Incident",
    //   },
    //   {
    //     id: "statusLaporan",
    //     label: "Status",
    //   },
    //   {
    //     id: "nomorinvestigasi",
    //     label: "No Investigasi",
    //   },
    //   { id: "statusinvestigasi", label: "Status Investigasi" },
    //   { id: "sladate", label: "SLA Date" },
    //   {
    //     id: "action",
    //     label: "",
    //   },
    // ]);

    await ApiService.postTaskListSummaryVerifikator({
      // page: 1,
      // itemPerPage: 100,
      page: page + 1,
      itemPerPage: rowsPerPage,
      regionId: regionId,
      locationId: locationId,
      year: year,
      tipeKejadianId: tipeKejadianId,
      filterSearch,
      isHipo: hipo === null ? null : hipo,
      filterNoLapInvestigasi: filterNoInvestigasi || '',
    })
      .then((res) => {
        let result = res.data.payload;
        setRows(result.data);
        setTotalRow(result.pagination.totalCount);
        setAuthorizeAction(result.authorizeAction);

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const getPostMyLkpTaskListSummaryVerifikator = async () => {
    await setRows([]);
    setLoading(true);

    await setNewColumnsTaskLkp([
      {
        id: 'nomorLkp',
        label: 'No LKP',
      },
      {
        id: 'judulLaporan',
        label: 'Judul',
      },
      {
        id: 'namaRegional',
        label: 'Region',
      },
      {
        id: 'tanggalLaporan',
        label: 'Date Reported',
      },
      {
        id: 'tipeInsiden',
        label: 'Tipe Incident',
      },
      {
        id: 'statusLkp',
        label: 'Status',
      },
      {
        id: 'action',
        label: '',
      },
    ]);

    await ApiService.postMyLkpTaskListSummaryVerifikator({
      // page: 1,
      // itemPerPage: 100,
      page: pageTaskLkp + 1,
      itemPerPage: rowsPerPageTaskLkp,
      regionId: regionId,
      locationId: locationId,
      year: year,
      tipeKejadianId: tipeKejadianId,
      filterSearch,
      isHipo: hipo === null ? null : hipo,
      filterNoLapInvestigasi: filterNoInvestigasi || '',
    })
      .then((res) => {
        let result = res.data.payload;

        setRowsTaskLkp(result.data);
        setTotalRowTaskLkp(result.pagination.totalCount);
        //setAuthorizeAction(result.authorizeAction);

        if (result.data.length > 0) {
          let isBadge = result.data.find((e) => {
            if (e.yourTurn == true) {
              return true;
            }
          });
          setIsBadgeTaskLKP(isBadge ? true : false);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };
  const getPostMyLapInvestTaskListSummaryVerifikator = async () => {
    setLoading(true);
    await setRows([]);

    await setNewColumnsLapInvest([
      {
        id: 'nomorInvestigasi',
        label: 'No Lap Investigasi',
      },
      {
        id: 'judulLaporan',
        label: 'Judul',
      },
      {
        id: 'namaRegional',
        label: 'Region',
      },
      {
        id: 'tanggalLaporan',
        label: 'Date Reported',
      },
      {
        id: 'picLapInvest',
        label: 'Pic. Investigasi',
      },
      {
        id: 'tipeInsiden',
        label: 'Tipe Incident',
      },
      {
        id: 'statusInvestigasi',
        label: 'Status',
      },
      {
        id: 'slaDate',
        label: 'Sla Date',
      },
      {
        id: 'action',
        label: '',
      },
    ]);

    await ApiService.postMyLapInvestTaskListSummaryVerifikator({
      // page: 1,
      // itemPerPage: 100,
      page: pageLapInvest + 1,
      itemPerPage: rowsPerPageLapInvest,
      regionId: regionId,
      locationId: locationId,
      year: year,
      tipeKejadianId: tipeKejadianId,
      filterSearch,
      isHipo: hipo === null ? null : hipo,
      filterNoLapInvestigasi: filterNoInvestigasi || '',
    })
      .then((res) => {
        let result = res.data.payload;

        setRowsLapInvest(result.data);
        setTotalRowLapInvest(result.pagination.totalCount);
        //setAuthorizeAction(result.authorizeAction);

        if (result.data.length > 0) {
          let isBadge = result.data.find((e) => {
            if (e.statusInvestigasi != 'Completed') {
              return true;
            }
          });
          setIsBadgeLapInvest(isBadge ? true : false);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.laporanKejadianId);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  // Handle Select
  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const emptyRows = () => {
    let newPage = value == 0 ? page : value == 1 ? pageTaskLkp : pageLapInvest;
    let newRowsPerPage =
      value == 0
        ? rowsPerPage
        : value == 1
        ? rowsPerPageTaskLkp
        : rowsPerPageLapInvest;
    return newPage > 0
      ? Math.max(0, (1 + newPage) * (newRowsPerPage - newPage.length))
      : 0;
  };

  // handle ganti halaman
  const handleChangePage = (event, newPage) => {
    // Perbarui halaman
    if (value == 0) {
      setPage(newPage);
    } else if (value == 1) {
      setPageTaskLkkp(newPage);
    } else {
      setPageLapInvest(newPage);
    }
  };

  // handle ganti max row
  const handleChangeRowsPerPage = (event) => {
    if (value == 0) {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    } else if (value == 1) {
      setRowsPerPageTaskLkp(parseInt(event.target.value, 10));
      setPageTaskLkkp(0);
    } else {
      setRowsPerPageLapInvest(parseInt(event.target.value, 10));
      setPageLapInvest(0);
    }
  };

  // Handle menghapus LKP
  const handleRemoveLkp = () => {
    const response = ApiService.deleteIncimanLkp(id);

    if (response.data.payload) {
      const updatedData = rows.filter(
        (row) => !selected.includes(row.laporanKejadianId)
      );

      setRows(updatedData);
    }

    setOpenDialog(false);
  };

  // Dialog Confirmation
  const [openDialog, setOpenDialog] = React.useState(false);
  const handleClickOpenDialog = (id) => {
    setId(id);
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  // Fetch Menu
  useEffect(() => {
    getDataRegion();
    getDataTahun();
    getDataInsiden();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getDataLokasi();
  }, [regionId]);
  const getDataRegion = () => {
    ApiService.getMsRegional().then((res) => {
      var result = res.data.payload;
      setDataRegion(result);
    });
  };
  const getDataLokasi = () => {
    if (!regionId) return;
    ApiService.getMsLokasi(regionId).then((res) => {
      var result = res.data.payload;
      setDataLokasi(result);
    });
  };
  const getDataTahun = () => {
    ApiService.getMsTahun().then((res) => {
      var result = res.data.payload;
      setDataTahun(result);
    });
  };
  const getDataInsiden = async () => {
    const dtInsiden = await ApiService.getMsTipeInsiden().then(
      (res) => res.data.payload
    );
    setDataInsiden(dtInsiden);
  };

  // Alert
  const [alertOpen, setAlertOpen] = useState(false);
  const [data, setData] = useState(null);
  const [type, setType] = useState(null);
  const [title, setTitle] = useState(null);
  const handleOpenAlert = (data, title, type) => {
    setData(data);
    setTitle(title);
    setType(type);
    setAlertOpen(true);
  };
  const handleCloseAlert = () => {
    setAlertOpen(false);
  };

  // Assign
  const [assignOpen, setAssignOpen] = useState(false);
  const handleOpenAssign = (data, title, type) => {
    setData(data);
    setTitle(title);
    setType(type);
    setAssignOpen(true);
  };
  const handleCloseAssign = () => {
    setAssignOpen(false);
  };

  // Dialog Save Berhasil
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };

  // Dialog Save Gagal
  const [open3, setOpen3] = useState(false);
  const [failMessage, setFailMessage] = useState('');
  const handleClose3 = () => {
    setOpen3(false);
  };

  // Dialog Delete Confirm
  const [open4, setOpen4] = useState(false);
  const handleOpenConfirmDelete = (data, title, type) => {
    setData(data);
    setTitle(title);
    setType(type);
    setOpen4(true);
  };
  const handleCloseConfirmDelete = () => {
    setOpen4(false);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);

    // if (newValue == 0) {
    //   getPostTaskListSummaryVerifikator();
    // } else if (newValue == 1) {
    //   getPostMyLkpTaskListSummaryVerifikator();
    // } else {
    //   getPostMyLapInvestTaskListSummaryVerifikator();
    // }
  };

  const exportToXLSX = (data) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(excelData, 'grid_data.xlsx');
  };

  const handleExport = async () => {
    setLoading(true);
    await ApiService.getListLkpSummary({
      regionId: regionId || 0,
      locationId: locationId || 0,
      year: year || 0,
      tipeKejadianId: tipeKejadianId || 0,
      filterSearch: filterSearch || '',
      isHipo: hipo === null ? null : hipo,
      filterNoLapInvestigasi: filterNoInvestigasi || '',
    })
      .then(({ data }) => {
        return data.payload || [];
      })
      .then((data) => {
        const convertedData = data.map((obj) => {
          const convertedObj = {};

          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const titleCaseKey = key
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, (str) => str.toUpperCase());
              convertedObj[titleCaseKey] = obj[key];
            }
          }

          return convertedObj;
        });
        exportToXLSX(convertedData);
        if (data) {
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Paper>
      <ButtonUser
        dataRegion={dataRegion}
        dataLokasi={dataLokasi}
        dataTahun={dataTahun}
        dataInsiden={dataInsiden}
        setRegionId={setRegionId}
        setHipo={setHipo}
        setLocationId={setLocationId}
        setYear={setYear}
        setTipeKejadianId={setTipeKejadianId}
        setFilterSearch={setFilterSearch}
        setFilterNoInvestigasi={setFilterNoInvestigasi}
      />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={'All Data LKP'} {...a11yProps(0)} />
          {isBadgeTaskLKP ? (
            <Tab
              label={
                <Badge badgeContent="!" color="error" sx={{ color: '#C0C0D5' }}>
                  <span style={{ marginRight: '10px' }}>My Task List LKP</span>
                </Badge>
              }
              {...a11yProps(1)}
            />
          ) : (
            <Tab label="My Task List LKP" {...a11yProps(1)} />
          )}

          {isBadgeLapInvest ? (
            <Tab
              label={
                <Badge badgeContent="!" color="error" sx={{ color: '#C0C0D5' }}>
                  <span style={{ marginRight: '10px' }}>
                    My Task List Lap. Investigasi
                  </span>
                </Badge>
              }
              {...a11yProps(2)}
            />
          ) : (
            <Tab label="My Task List Lap. Investigasi" {...a11yProps(2)} />
          )}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <TableContainer sx={{ overflow: 'visible' }}>
          {authorizeAction && authorizeAction.lkP_EXPORT_TO_EXCEL === true ? (
            <Button
              variant="contained"
              startIcon={<ExcelIcon />}
              sx={{ m: 1, minWidth: 120 }}
              onClick={handleExport}
            >
              Export to Excel
            </Button>
          ) : null}

          <Table sx={{ minWidth: '100%' }} aria-labelledby="tableTitle">
            <EnhancedTableHead
              columns={columns}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {loading ? (
                <div className="spinerr">
                  <CircularProgress />
                </div>
              ) : null}

              {stableSort(rows, getComparator(order, orderBy)).map(
                (row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                      selected={isItemSelected}
                    >
                      <TableCell>{row.nomorLkp}</TableCell>
                      <TableCell>{row.judulLaporan}</TableCell>
                      <TableCell>
                        {moment(row.tanggalLaporan).format('DD MMM YYYY')}
                      </TableCell>
                      <TableCell>{row.tipeInsiden}</TableCell>
                      <TableCell>
                        <>
                          {row.isStatus === 'I' ? (
                            <div
                              style={{
                                backgroundColor: 'grey',
                                borderRadius: '5px',
                                padding: '8px 0',
                                width: '100px',
                                alignItems: 'center',
                                textAlign: 'center',
                                fontColor: 'white',
                              }}
                            >
                              DELETED
                            </div>
                          ) : row.statusLkp.toLowerCase() === 'issued' &&
                            row.perluInsidentAlert === null &&
                            row.perluDilakukanInvestigasi === null ? (
                            <Badge
                              badgeContent="!"
                              color="error"
                              sx={{ color: '#C0C0D5' }}
                            >
                              <div
                                style={{
                                  backgroundColor: '#FF5733',
                                  borderRadius: '5px',
                                  padding: '8px 0',
                                  width: '100px',
                                  alignItems: 'center',
                                  textAlign: 'center',
                                  color: 'yellow',
                                }}
                              >
                                {row.statusLkp}
                              </div>
                            </Badge>
                          ) : (
                            <div
                              style={{
                                backgroundColor:
                                  row.statusLkp.toLowerCase() === 'verified' ||
                                  row.flagSlaTime?.toLowerCase() === 'grey'
                                    ? '#E3E3ED'
                                    : row.statusLkp.toLowerCase() ===
                                        'completed' ||
                                      row.flagSlaTime?.toLowerCase() === 'green'
                                    ? '#92D050'
                                    : row.flagSlaTime?.toLowerCase() ===
                                      'yellow'
                                    ? '#FFCF03'
                                    : row.flagSlaTime?.toLowerCase() === 'red'
                                    ? '#FF0000'
                                    : '#FF5733',
                                borderRadius: '5px',
                                padding: '8px 0',
                                width: '100px',
                                alignItems: 'center',
                                textAlign: 'center',
                              }}
                            >
                              {row.statusLkp}
                            </div>
                          )}
                        </>
                      </TableCell>
                      <TableCell>{row.nomorInvestigasi || '-'}</TableCell>
                      <TableCell>{row.statusInvestigasi || '-'}</TableCell>
                      <TableCell>
                        {row.slaDate
                          ? moment(row.slaDate).format('DD MMM YYYY')
                          : '-'}
                      </TableCell>

                      <TableCell>
                        <DropdownActionLkp
                          authorizeAction={authorizeAction}
                          item={row}
                          handleOpenAlert={handleOpenAlert}
                          handleOpenAssign={handleOpenAssign}
                          handleOpenConfirmDelete={handleOpenConfirmDelete}
                        />
                      </TableCell>
                    </TableRow>
                  );
                }
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRow}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <TableContainer sx={{ overflow: 'visible' }}>
          <Table sx={{ minWidth: '100%' }} aria-labelledby="tableTitle">
            <EnhancedTableHead
              columns={newColumnsTaskLkp}
              numSelected={selected.length}
              // order={order}
              // orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {loading ? (
                <div className="spinerr">
                  <CircularProgress />
                </div>
              ) : null}

              {rowsTaskLkp.map((row, index) => {
                const isItemSelected = isSelected(row.name);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.name}
                    selected={isItemSelected}
                  >
                    <TableCell>{row.nomorLkp}</TableCell>
                    <TableCell>{row.judulLaporan}</TableCell>
                    <TableCell>{row.namaRegional}</TableCell>
                    <TableCell>
                      {moment(row.tanggalLaporan).format('DD MMM YYYY')}
                    </TableCell>
                    <TableCell>{row.tipeInsiden}</TableCell>
                    <TableCell>
                      <div
                        style={{
                          backgroundColor:
                            row.statusLkp.toLowerCase() === 'verified' ||
                            row.flagSlaTime?.toLowerCase() === 'grey'
                              ? '#E3E3ED'
                              : row.statusLkp.toLowerCase() === 'completed' ||
                                row.flagSlaTime?.toLowerCase() === 'green'
                              ? '#92D050'
                              : row.flagSlaTime?.toLowerCase() === 'yellow'
                              ? '#FFCF03'
                              : row.flagSlaTime?.toLowerCase() === 'red'
                              ? '#FF0000'
                              : '#FF5733',
                          borderRadius: '5px',
                          padding: '8px 0',
                          width: '100px',
                          alignItems: 'center',
                          textAlign: 'center',
                        }}
                      >
                        {row.statusLkp}
                      </div>
                    </TableCell>
                    <TableCell>
                      <Stack spacing={2} direction="row">
                        <IconButton
                          onClick={() => {
                            EditData(row.paramLkpEncode);
                            console.log(row.paramLkpEncode);
                          }}
                        >
                          {row.yourTurn === true ? (
                            <Badge
                              badgeContent="!"
                              color="error"
                              sx={{ color: '#C0C0D5' }}
                            >
                              <EditIcon />
                            </Badge>
                          ) : row.toYou === true ? (
                            <Badge
                              badgeContent="!"
                              color="warning"
                              sx={{ color: '#000000' }}
                            >
                              <EditIcon />
                            </Badge>
                          ) : (
                            <EditIcon />
                          )}
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRowTaskLkp}
          rowsPerPage={rowsPerPageTaskLkp}
          page={pageTaskLkp}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <TableContainer sx={{ overflow: 'visible' }}>
          <Table sx={{ minWidth: '100%' }} aria-labelledby="tableTitle">
            <EnhancedTableHead
              columns={newColumnsLapInvest}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {loading ? (
                <div className="spinerr">
                  <CircularProgress />
                </div>
              ) : null}

              {rowsLapInvest.map((row, index) => {
                const isItemSelected = isSelected(row.name);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.name}
                    selected={isItemSelected}
                  >
                    <TableCell>{row.nomorInvestigasi}</TableCell>
                    <TableCell>{row.judulLaporan}</TableCell>
                    <TableCell>{row.namaRegional}</TableCell>
                    <TableCell>
                      {moment(row.tanggalLaporan).format('DD MMM YYYY')}
                    </TableCell>
                    <TableCell>{row.picLapInvest}</TableCell>
                    <TableCell>{row.tipeInsiden}</TableCell>
                    {/* <TableCell>
                        <div
                          style={{
                            backgroundColor:
                              row.statusLkp.toLowerCase() === "verified" ||
                              row.flagSlaTime?.toLowerCase() === "grey"
                                ? "#E3E3ED"
                                : row.statusLkp.toLowerCase() === "completed" ||
                                  row.flagSlaTime?.toLowerCase() === "green"
                                ? "#92D050"
                                : row.flagSlaTime?.toLowerCase() === "yellow"
                                ? "#FFCF03"
                                : row.flagSlaTime?.toLowerCase() === "red"
                                ? "#FF0000"
                                : "#FF5733",
                            borderRadius: "5px",
                            padding: "8px 0",
                            width: "100px",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          {row.statusLkp}
                        </div>
                      </TableCell> */}
                    {/* <TableCell>{row.nomorInvestigasi || "-"}</TableCell> */}
                    <TableCell>{row.statusInvestigasi || '-'}</TableCell>
                    <TableCell>
                      {row.slaDate
                        ? moment(row.slaDate).format('DD MMM YYYY')
                        : '-'}
                    </TableCell>

                    <TableCell>
                      <Stack spacing={2} direction="row">
                        <IconButton
                          onClick={() => {
                            if (
                              row.idTblLkpLaporanInvestigasi === null ||
                              row.idTblLkpLaporanInvestigasi === 0
                            ) {
                              navigate(
                                `/hsse/incident/lapinvestigasi/create/${row.paramInvestigasiEncode}`,
                                {
                                  state: { data: row },
                                }
                              );
                            } else {
                              navigate(
                                `/hsse/incident/lapinvestigasi/view/${row.paramInvestigasiEncode}`,
                                {
                                  state: {
                                    data: { ...row, isEditMode: true },
                                  },
                                }
                              );
                            }
                          }}
                        >
                          {row.statusInvestigasi !== 'Completed' ? (
                            <Badge
                              badgeContent="!"
                              color="error"
                              sx={{ color: '#C0C0D5' }}
                            >
                              <EditIcon />
                            </Badge>
                          ) : (
                            <EditIcon />
                          )}
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRowLapInvest}
          rowsPerPage={rowsPerPageLapInvest}
          page={pageLapInvest}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TabPanel>

      {/* Dialog */}
      {data !== null && (
        <DialogIncidentAlert
          dialogOpen={alertOpen}
          handleCloseDialog={handleCloseAlert}
          data={data}
          type={type}
          title={title}
          setFailMessage={setFailMessage}
          setOpen3={setOpen3}
          setOpen2={setOpen2}
          setAlertOpen={setAlertOpen}
        />
      )}

      {/* Dialog */}
      {data !== null && (
        <DialogDeleteConfirmation
          dialogOpen={open4}
          handleCloseDialog={handleCloseConfirmDelete}
          data={data}
          type={type}
          title={title}
          setFailMessage={setFailMessage}
          setOpen4={setOpen4}
          setOpen3={setOpen3}
          setOpen2={setOpen2}
          setAlertOpen={setAlertOpen}
        />
      )}

      {data !== null && (
        <DialogAssignPic
          dialogOpen={assignOpen}
          setAssignOpen={setAssignOpen}
          data={data}
          type={type}
          title={title}
          setFailMessage={setFailMessage}
          setOpen3={setOpen3}
          setOpen2={setOpen2}
          setAlertOpen={setAlertOpen}
        />
      )}

      {/* Dialog Save Berhasil */}
      <DialogCustom
        open={open2}
        handleClose={handleClose2}
        title={
          <>
            Notifikasi
            {handleClose2 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose2}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={<>Berhasil Membuat LKP {type}</>}
      />

      {/* Dialog Save GAGAL */}
      <DialogCustom
        open={open3}
        handleClose={handleClose3}
        title={
          <>
            Notifikasi
            {handleClose3 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose3}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={<>{failMessage}</>}
        actions={
          <>
            <Button onClick={handleClose3} autoFocus variant="contained">
              Tutup
            </Button>
          </>
        }
      />

      {/* Confirmation Message */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Are you sure to remove this task?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You can't undone process once task removed. Removed task can't be
            restore.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleRemoveLkp} autoFocus>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default TableBawah;
